export function getMonthTypeInputValueFromDate(date: Date | null): string {
  if (!date) return "";
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const monthWithPaddingAtStart = month.toString().padStart(2, "0");
  return `${year}-${monthWithPaddingAtStart}`;
}
